/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';
//import { Grid, Box } from '@mui/material';

export const SelectedItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const ClearBtnSection = styled.div`
  width: 100%;
  height: 48px;
  background: ${Palette.PrimaryGray._000};
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
// export const MyBox = styled(Box)`
//   background: ${Palette.PrimaryGray._100};
//   width: 100%;
// `;
// export const MyGrid = styled(Grid)`
//   padding: 16px;
//   gap: 10px;
// `;

export const MultipleItemsSelectionComponent = styled.div`
  display: flex;
  width: 600px;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: #f8fafc;
  box-shadow: inset 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: ${({ showBorder }) => showBorder && `1px solid ${Palette.Red._300}`};
`;

export const Box = styled.div`
  padding: 16px;
  width: 100%;
  background: ${Palette.PrimaryGray._100};
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
`;
